import Glightbox from 'glightbox';

export default class SingleLightbox {
  constructor() {
    this.lightbox = Glightbox({
      selector: '.js-glightbox'
    });
  }
}
